<div class="modal-content">
    <h1 mat-dialog-title>
        {{ Title }}
    </h1>
    <div mat-dialog-content class="dialog-content">
        <p>
            <b>{{Subtitle}}</b>
        </p>
        <p>
            {{ Message }}
        </p>
    </div>
    <div class="action-button-container" mat-dialog-actions align="end">
        <button
            id="confirm-dialog-cancel"
            mat-flat-button
            (click)="OnCancelClick()"
            color="accent"
            class="btn-sm">
            Cancel
        </button>
        <button *ngIf="!IsDeleteAction"
            id="confirm-dialog-accept"
            mat-flat-button
            (click)="OnConfirmClick()"
            color="primary"
            class="btn-sm">
            Confirm
        </button>
        <button *ngIf="IsDeleteAction"
            id="confirm-dialog-discard"
            mat-flat-button
            (click)="OnConfirmClick()"
            color="warn"
            class="btn-sm">
            Discard
        </button>
    </div>
</div>